export enum DocumentRequestOrigin {
  RH = 'RH',
  EMPLOYEE = 'EMPLOYEE',
  COMPLIANCE = 'COMPLIANCE',
}
